/* eslint-disable import/no-anonymous-default-export */

const lightPalette = {
  mode: 'light',
  primary: {
    100: '#EEF2FF',
    200: '#C7D2FE',
    300: '#A5B4FC',
    400: '#818CF8',
    500: '#6366F1',
    600: '#4F46E5',
    700: '#4338CA',
    800: '#3730A3',
    900: '#312E81',
    light: '#818CF8',
    main: '#6366F1',
    dark: '#4338CA',
    contrastText: '#fff',
  },
  secondary: {
    100: '#FCE7F3',
    200: '#FBCFE8',
    300: '#F9A8D4',
    400: '#F472B6',
    500: '#EC4899',
    600: '#DB2777',
    700: '#BE185D',
    800: '#9D174D',
    900: '#831843',
    main: '#EC4899',
    dark: '#DB2777',
    light: '#F9A8D4',
    contrastText: '#fff',
  },
  accent: {
    main: '#F59E0B',
    light: '#FCD34D',
    dark: '#D97706',
    contrastText: '#fff',
  },
  grey: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  error: {
    main: '#EF4444',
    light: '#FCA5A5',
    dark: '#DC2626',
    contrastText: '#fff',
  },
  warning: {
    main: '#F59E0B',
    light: '#FCD34D',
    dark: '#D97706',
    contrastText: '#fff',
  },
  success: {
    main: '#10B981',
    light: '#6EE7B7',
    dark: '#059669',
    contrastText: '#fff',
  },
  info: {
    main: '#3B82F6',
    light: '#93C5FD',
    dark: '#2563EB',
    contrastText: '#fff',
  },
  divider: 'rgba(99, 102, 241, 0.08)',
  background: {
    default: '#F8FAFC',
    paper: '#FFFFFF',
    glass: 'rgba(255, 255, 255, 0.8)',
    elevated: '#FFFFFF',
  },
  text: {
    primary: '#0F172A',
    secondary: '#475569',
    disabled: '#94A3B8',
  },
  common: {
    black: '#000',
    white: '#fff',
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
}

const darkPalette = {
  mode: 'dark',
  primary: {
    100: '#312E81',
    200: '#3730A3',
    300: '#4338CA',
    400: '#4F46E5',
    500: '#6366F1',
    600: '#818CF8',
    700: '#A5B4FC',
    800: '#C7D2FE',
    900: '#EEF2FF',
    light: '#A5B4FC',
    main: '#818CF8',
    dark: '#4F46E5',
    contrastText: '#fff',
  },
  secondary: {
    main: '#F472B6',
    dark: '#EC4899',
    light: '#FBCFE8',
    contrastText: '#fff',
  },
  accent: {
    main: '#FBBF24',
    light: '#FCD34D',
    dark: '#F59E0B',
    contrastText: '#000',
  },
  grey: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  error: {
    main: '#F87171',
    light: '#FCA5A5',
    dark: '#EF4444',
    contrastText: '#fff',
  },
  warning: {
    main: '#FBBF24',
    light: '#FCD34D',
    dark: '#F59E0B',
    contrastText: '#000',
  },
  success: {
    main: '#34D399',
    light: '#6EE7B7',
    dark: '#10B981',
    contrastText: '#000',
  },
  info: {
    main: '#60A5FA',
    light: '#93C5FD',
    dark: '#3B82F6',
    contrastText: '#fff',
  },
  divider: 'rgba(255, 255, 255, 0.08)',
  background: {
    default: '#070B14',
    paper: '#0F1629',
    glass: 'rgba(15, 22, 41, 0.8)',
    elevated: '#161E35',
  },
  text: {
    primary: '#F1F5F9',
    secondary: '#94A3B8',
    disabled: '#475569',
  },
  common: {
    black: '#000',
    white: '#fff',
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
}

export { lightPalette, darkPalette }
export default lightPalette
